import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminQueueAthenaPracticeSetUpMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminQueueAthenaPracticeSetUpMutationResultFragment, AdminQueueAthenaPracticeSetUpMutationParams } from '@docpace/admin-graphql'

const typedAdminQueueAthenaPracticeSetUpMutationDocument = AdminQueueAthenaPracticeSetUpMutationDocument as TypedDocumentNode<AdminQueueAthenaPracticeSetUpMutationResultFragment, Partial<AdminQueueAthenaPracticeSetUpMutationParams>>

export function useAdminQueueAthenaPracticeSetUpMutation(opts?: useMutation.Options<AdminQueueAthenaPracticeSetUpMutationResultFragment, Partial<AdminQueueAthenaPracticeSetUpMutationParams>>){
    return useMutation(typedAdminQueueAthenaPracticeSetUpMutationDocument, opts)
}
